module.exports = __webpack_public_path__ + "img/ow-event.8d14cfea.jpg";